import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=38d262fc&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=38d262fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d262fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d262fc')) {
      api.createRecord('38d262fc', component.options)
    } else {
      api.reload('38d262fc', component.options)
    }
    module.hot.accept("./UsersList.vue?vue&type=template&id=38d262fc&scoped=true&", function () {
      api.rerender('38d262fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UsersList.vue"
export default component.exports